var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"center-active":""},model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},_vm._l((_vm.tabOptions),function(tab,idx){return _c('v-tab',{key:idx,attrs:{"return-value":true}},[_vm._v(" "+_vm._s(tab)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }